export const roadmaps = [
    {
        id: 1,
        title: 'H1 2021',
        text: 'Seed Fundraise <br/> MVP Release',
        status: 'active',
    },{
        id: 2,
        title: 'H2 2021',
        text: 'Devnet Release',
        status: 'current',
    },{
        id: 3,
        title: '2022',
        text: 'Testnet Release <br/> Incentivized Testnet',
        status: 'active',
    },{
        id: 4,
        title: '2022',
        text: 'Mainnet Launch',
        status: 'active',
    },
]
